export default __webpack_public_path__ + "static/media/WhatsApp.b750e9a9.svg";